import { Component, OnInit } from '@angular/core';
import { ColumnHeader } from 'src/app/models/column-header';
import { CommonService } from 'src/app/services/common-service/common.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Labels } from 'src/app/constants/labels';
import { RoutePath } from 'src/app/constants/routerPath';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from 'src/app/components/modal/confirm-modal/confirm-modal.component';
import { KEYS } from 'src/app/constants/keys';
import { isData, isPresent } from 'src/app/utils/utils';
import { SrcPath } from 'src/app/constants/srcPath';
// import { WebcamImage, WebcamInitError} from 'ngx-webcam'; 
// import { Subject, Observable } from "rxjs";


import { Observable, Subject } from 'rxjs';
import { WebcamImage, WebcamModule } from 'ngx-webcam';
import { WebcamUtil } from 'src/app/modules/webcam/util/webcam.util';
import { WebcamInitError } from 'src/app/modules/webcam/domain/webcam-init-error';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';


@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  imports:[CommonModule,FormsModule,WebcamModule,SharedModule,ReactiveFormsModule,JsonPipe]
})
export class PagesComponent implements OnInit {
  headerData: ColumnHeader | any;
  pageListData: any = [];
  labelMessages = Labels.messages;
  labelPage = Labels.page;
  labelButton = Labels.buttons;
  bsModalRef!: BsModalRef;
  isSuperaDmin: boolean = false;
  dbPath: any;
  moduleListdata: any = [];
  menuListdata: any = [];
  menuWisePageListdata: any = [];
  srcPath = SrcPath;
  labelMessage = Labels.messages;
  /*
    public seconds: number;
    private trigger: Subject<void> = new Subject<void>();  
    // latest snapshot
    public webcamImage: WebcamImage = null;
  */
  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId!: string;
  public facingMode: string = 'environment';
  public errors: WebcamInitError[] = [];


  // latest snapshot
  public webcamImage: WebcamImage | any = null;


  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  menumoduleorderData: any[] = [];
  staticPageslist: any[] = [];
  parentMenus: any;
  adminMenuIcon = SrcPath.adminMenuIcon;
  messageLabel = Labels.messages;


  constructor(private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService,
    private modalService: BsModalService) {
  }



  public triggerSnapshot(): void {
    this.trigger.next();
  }


  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }


  public handleInitError(error: any | WebcamInitError): void {
    if (error.mediaStreamError && error.mediaStreamError.name === 'NotAllowedError') {
      console.warn('Camera access was not allowed by user!');
    }
    this.errors.push(error);
  }


  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }


  public handleImage(webcamImage: WebcamImage): void {
    this.commonService.ogLog('received webcam image', webcamImage);
    this.webcamImage = webcamImage;
  }


  public cameraWasSwitched(deviceId: any): void {
    this.commonService.ogLog('active device: ' + deviceId);
    this.deviceId = deviceId;
  }


  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }


  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }


  public get videoOptions(): MediaTrackConstraints {
    const result: MediaTrackConstraints = {};
    if (this.facingMode && this.facingMode !== '') {
      result.facingMode = { ideal: this.facingMode };
    }


    return result;
  }



  /*
    public triggerSnapshot(): void {
      this.trigger.next();
      this.seconds = 3;
      setTimeout(() => {
        this.seconds = 2;
        setTimeout(() => {
          this.seconds = 1;
          setTimeout(() => {
            
            this.seconds = null;
          }, 2000);
        }, 2000);
      }, 2000);
      
    }
  
    public handleImage(webcamImage: WebcamImage): void{
      this.webcamImage = webcamImage;
      console.log("this.webcamImage, ",this.webcamImage);
    }
  
    public get triggerObservable(): Observable<void>{
      return this.trigger.asObservable();
    }
    public handleInitError(error: WebcamInitError): void{
      console.log("this.error, ",error);
    }
  */
  ngOnInit(): void {
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });

    this.isSuperAdmin();
    this.initHeaderColumn();
    this.getPageListData();
  }
  isSuperAdmin() {
    const sessionSuperAdmin = sessionStorage.getItem(KEYS.isSuperAdmin);
    if (sessionSuperAdmin)
      this.isSuperaDmin = JSON.parse(sessionSuperAdmin);
    if (this.isSuperaDmin) {
      const sessionCustomerPath = sessionStorage.getItem(KEYS.customerDbPath);
      if (sessionCustomerPath)
        this.dbPath = JSON.parse(sessionCustomerPath);
    }
  }
  private initHeaderColumn() {
    this.headerData = {
      title: this.labelPage.pages,
      button: {
        show: true,
        name: this.labelButton.create_new_page
      },
      topButton: {
        show: false
      }
    };
  }

  viewPage(pageData: any) {
    const pageDetails = {
      pageId: pageData.gstibo_page_id,
      pageName: pageData.gstibo_page_name
    }
    sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
    this.router.navigate([RoutePath.mainPageLayout, pageDetails.pageName]);
  }

  editPage(pageData: any) {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    if (pageData['pagetype'] == 'S') {
      this.commonService.loadStaticPageDetailsById(dbFullPath, pageData['gstibo_menu_id']).subscribe((adata: any) => {
        isData(adata)
        {
          sessionStorage.setItem(KEYS.pageDetailsEdit, JSON.stringify(adata['table'][0]));
        }
      });
    }
    else {
      this.commonService.loadPageDetailsById(dbFullPath, pageData['gstibo_page_id']).subscribe((adata: any) => {
        isData(adata['table'])
        {
          sessionStorage.setItem(KEYS.pageDetailsEdit, JSON.stringify(adata['table'][0]));
        }
      });
    }


    this.router.navigate([RoutePath.createNewPage],
      {
        queryParams: {
          pageId: pageData['gstibo_page_id'],
          pageDetails: JSON.stringify(pageData)
        }
      });
  }

  deletePage(pageId: any, pageName: any) {
    let ipaddress = '', machinename = '';
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.bsModalRef = this.modalService.show(ConfirmModalComponent, {
      animated: true, class: KEYS.confirmModal
    });
    this.bsModalRef.content.data = {
      title: this.labelMessages.title_confirm,
      message: this.labelMessages.delete_confirm_msg.message,
      btnConfirm: this.labelMessages.title_confirm,
      btnCancel: this.labelMessages.button_cancel.message,
      btnConfirmStyle: 'btn-red',
      btnCancelStyle: 'btn-green'
    }
    this.bsModalRef.content.buttonevent.subscribe((res: any) => {
      if (res) {
        this.commonService.deletePage(dbFullPath, pageId, this.commonService.getUserCredentials(KEYS.credential_customer_id)).subscribe((data: any) => {
          if (isData(data)) {
            let pageTblCnt = (data['table'][0]).tbl_cnt;
            if (pageTblCnt > 0) {
              //this.toastr.error('Cannot be deleted. Data already used.');
               this.commonService.showModalValidate('Cannot be deleted. Data already used.','',this.messageLabel.static_messages.error,'Cannot be deleted. Data already used.');
            }
            else {
              this.getPageListData();
             //this.toastr.success(this.labelMessages.delete_success_msg.message);
              this.commonService.showModalValidate(this.labelMessages.delete_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.delete_success_msg.message);
              let msg = 'Deleted Page Id:' + pageId + " Page Name:" + pageName;
              this.commonService.saveAuditTrialAdmin(dbFullPath, pageId, 0, 0, KEYS.saveType.DELETE, ipaddress, machinename,
                this.commonService.getUserCredentials(KEYS.credential_customer_id), msg,
                this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe(auditdata => {
                },
                  error => {
                    console.log('generateAuditTrail Error:', error);
                  });
            }
          }
        });
      }
    });
  }

  getPageListData() {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadPageList(dbFullPath).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      this.pageListData = data['table'];
      this.loadOrderMenuData(0);
      // this.loadStaticMenu();
      // this.LoadAllMenu();
      this.commonService.ogLog(this.menuWisePageListdata);
      this.menuWisePageListdata = this.menuWisePageListdata.sort((a: any, b: any) => (a.moduleorder - b.moduleorder));
    });
  }
  LoadAllMenu() {
    this.menuListdata = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadMenu(dbFullPath, this.commonService.getUserCredentials(KEYS.credential_customer_id)).subscribe((data: any) => {
      if (isData(data)) {
        this.menuListdata = data['table'];

        this.staticPageslist.forEach((element: any) => {
          this.menuListdata.push(
            {
              'gstibo_menu_name': element.gstibo_menu_name,
              'gstibo_menu_id': element.gstibo_menu_id,
              'moduleid': element.gstibo_menu_id,
              'module_id': element.gstibo_is_show_parentmodule_Id,
              'gstibo_menu_icon': 'timesheet',
              'pgid': element.gstibo_page_id,
              'child': data['table'].filter((x: any) => (x.gstibo_parent_menu_id == element.gstibo_menu_id ||
                x.parent == element.gstibo_menu_id) && x.gstibo_menu_type == 1 && x.parent_menu_id == 0),
              'pagetype': 'S',
              'gstibo_parent_menu_id': element.gstibo_is_show_parentmodule_Id,
              'moduleorder': (element.gstibo_menu_name == 'Settings' ? 20 : element.moduleorder)
            });

        });
        this.commonService.ogLog('this.menuListdata', this.menuListdata)
        this.menuListdata = this.menuListdata.sort((a: any, b: any) => (a.moduleorder - b.moduleorder));
        this.moduleListdata = data['table'].filter((x: any) => x.gstibo_parent_menu_id == 0);
        this.moduleListdata.forEach((element: any) => {
          let childmenues = this.menuListdata.filter((x: any) => x.gstibo_parent_menu_id == element.gstibo_menu_id);
          let childPages: any = [];
          childmenues.forEach((child: any) => {
            let pages = this.pageListData.filter((x: any) => x.gstibo_with_menu_group_id == child.gstibo_menu_id);
            this.commonService.ogLog('pagesd', pages);
            pages.forEach((ele: any) => {
              childPages.push(
                {
                  'gstibo_page_id': ele.gstibo_page_id,
                  'gstibo_page_name': ele.gstibo_page_name,
                  'gstibo_app_description': ele.gstibo_app_description,
                  'gstibo_icon': ele.gstibo_icon,
                  'gstibo_bg_color': ele.gstibo_bg_color,
                  'gstibo_menu_style': ele.gstibo_menu_style,
                  'gstibo_linked_page': ele.gstibo_linked_page,
                  'gstibo_linked_page_static': ele.gstibo_linked_page_static,
                  'gstibo_popup_width': ele.gstibo_popup_width,
                  'gstibo_is_same_page_table': ele.gstibo_is_same_page_table,
                  'gstibo_table_name': ele.gstibo_table_name,
                  'gstibo_with_menu_group_id': ele.gstibo_with_menu_group_id,
                  'module_id': (ele.pagetype == 'S' ? ele.moduleid : child.moduleid),
                  'pagetype': (ele.pagetype == null ? 'D' : ele.pagetype),
                  'gstibo_menu_id': ele.gstibo_menu_id,
                  'pgid': ele.gstibo_menu_id,
                  'moduleorder': (element.gstibo_menu_name == 'Settings' ? 20 : 22),
                });
            });
          });
          this.menuWisePageListdata.push(
            {
              'parent_menu_name': element.gstibo_menu_name,
              'parent_menu_id': element.gstibo_menu_id,
              // 'gstibo_menu_name': child.gstibo_menu_name,
              // 'gstibo_menu_id': child.gstibo_menu_id,
              'child': childPages,
              'moduleorder': (element.gstibo_menu_name == 'Settings' ? 20 : element.moduleorder)
            });



        });

        this.menuWisePageListdata.push(
          {
            'parent_menu_name': 'Others',
            'parent_menu_id': 0,
            // 'gstibo_menu_name': child.gstibo_menu_name,
            // 'gstibo_menu_id': child.gstibo_menu_id,
            'child': this.pageListData.filter((x: any) => !isPresent(x.gstibo_with_menu_group_id)),
            'moduleorder': 21
          });
      } else {
        this.commonService.ogLog('data not available');
      }
    },
      error => {
        console.log('executeLogicAppsApi Error:', error);
      });
    this.menuWisePageListdata = this.menuWisePageListdata.sort((a: any, b: any) => (a.moduleorder - b.moduleorder));


  }
  loadOrderMenuData(menuid: any) {
    this.commonService.getModulemenuorderlist(menuid).subscribe((data: any) => {
      if (isData(data)) {
        if (this.menumoduleorderData.length == 0) {
          this.menumoduleorderData = data['table'];
          this.loadStaticMenu();
        }
      }
    });
  }
  loadStaticMenu() {

    let userAccountID = this.commonService.getUserCredentials(KEYS.credential_customer_id);
    this.commonService.loadStaticMenuForUser(userAccountID).subscribe((data: any) => {
      if (isData(data)) {
        this.staticPageslist = [];
        this.staticPageslist = data['table'];
        this.staticPageslist.forEach((element: any) => {
          this.pageListData.push({
            'gstibo_menu_name': element.gstibo_menu_name,
            'gstibo_page_name': element.gstibo_menu_name,
            'gstibo_menu_id': element.gstibo_menu_id,
            'moduleid': element.gstibo_is_show_parentmodule_Id,
            'module_id': element.gstibo_menu_id,
            'gstibo_icon': 'timesheet',
            'pgid': element.gstibo_page_id,
            'pagetype': 'S',
            'gstibo_with_menu_group_id': element.gstibo_menu_id,
            'child': data['table'].filter((x: any) => (x.gstibo_parent_menu_id == element.gstibo_menu_id ||
              x.parent == element.gstibo_menu_id) && x.gstibo_menu_type == 1 && x.parent_menu_id == 0)
          })

        });
      }
    });
    this.LoadAllMenu();
  }
}
